@let vuln = vulnerability();
@if (vuln) {
  <comp-vulnerability-id-list [vulnerability]="vuln"></comp-vulnerability-id-list>
} @else {
  {{ finding().name }}
}
